import React from 'react';
import { Star, Award, Hammer, Ruler, Clock, MapPin } from 'lucide-react';
import { features } from '../mock';

const iconMap = {
  Star: Star,
  Award: Award,
  Hammer: Hammer,
  Ruler: Ruler,
  Clock: Clock,
  MapPin: MapPin
};

export const Features = () => {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-block px-4 py-2 bg-[#1c2536]/10 rounded-full mb-6">
            <span className="text-[#1c2536] font-semibold text-sm">WHY CHOOSE US</span>
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            Quality You Can Rely On
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Trusted by homeowners across Hull for exceptional craftsmanship and service
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature) => {
            const IconComponent = iconMap[feature.icon];
            return (
              <div
                key={feature.id}
                className="group relative p-8 rounded-2xl bg-gradient-to-br from-stone-50 to-white border border-gray-200 hover:border-[#1c2536]/30 hover:shadow-xl transition-all duration-300"
              >
                {/* Icon */}
                <div className="w-14 h-14 rounded-xl flex items-center justify-center mb-6 shadow-lg group-hover:scale-110 group-hover:rotate-3 transition-all duration-300" style={{ backgroundColor: '#1c2536' }}>
                  <IconComponent className="w-7 h-7 text-white" />
                </div>

                {/* Content */}
                <h3 className="text-xl font-bold text-gray-900 mb-2 group-hover:text-[#1c2536] transition-colors">
                  {feature.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {feature.description}
                </p>

                {/* Decorative element */}
                <div className="absolute top-0 right-0 w-20 h-20 bg-[#1c2536]/10 rounded-bl-full opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
